import React from 'react';
import { GameInterface } from '../constants/GameInterface';
import { Round } from '../classes/Round';
import { Player } from '../classes/Player';
import { getBlackCardText, getRedCardText } from '../utils/TextsUtils';
import { getCriminalImageSubPath } from '../utils/AvatarUtils';
import { disclaimerText2 } from '../constants/Constants';

interface RoundWinnerDialogInterface {
    currentRound: Round;
    criminal: Player;
    winningBlackCardIdx: number;
    roundWinnerName: string;
    timeInSeconds: number;
}

function RoundWinnerDialog({currentRound, criminal, winningBlackCardIdx, roundWinnerName, timeInSeconds}: RoundWinnerDialogInterface) {
    const subPath = getCriminalImageSubPath(criminal.gender)
    const playerImage = require("../images/" + subPath + "/" + criminal.image + ".png");

    return (
        <div className="roundWinnerOuterWrapper">
            <div className="roundWinnerWrapper">
                <img className="roundWinnerCriminalImage" src={playerImage} alt="red card receiver"/>
                <div className="roundWinnerTimer">
                    {String(timeInSeconds) + "s"}
                </div>
                <div className="roundWinnerContentDisclaimerWrapper">
                    <div className="roundWinnerContentWrapper">
                        <div className="roundWinnerCrimeText">
                            {getRedCardText(currentRound.redCardIdx, criminal.name, criminal.gender)}
                        </div>
                        <div className="roundWinnerKarmaText">
                            {"Karma: " + getBlackCardText(winningBlackCardIdx, criminal.name, criminal.gender)}
                        </div>
                        <div className="roundWinnerSubmittedByText">
                            {"Submitted by " + roundWinnerName}
                        </div>
                    </div>
                    <div className="roundWinnerDisclaimerText">{"Disclaimer: " + disclaimerText2}</div>
                </div>
            </div>
        </div>
    );
};

export default RoundWinnerDialog;